import { render, staticRenderFns } from "./ModalCadastroTalento.vue?vue&type=template&id=1e5a2a1e"
import script from "./ModalCadastroTalento.vue?vue&type=script&lang=js"
export * from "./ModalCadastroTalento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports